export const polyfills = (): Promise<Function[]> => {
  const imports = [import('intersection-observer')];

  if (!('URLSearchParams' in window)) {
    imports.push(import('url-search-params-polyfill'));
  }

  return Promise.all(imports);
};
